import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { NotificationService } from '@progress/kendo-angular-notification';
import * as _ from 'lodash';
import * as moment from 'moment';
import { startWith } from 'rxjs';
import { AdminService } from 'src/app/modules/dashboard/services/admin.service';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { IEPService } from 'src/app/modules/iep/iep-document/services/iep.services';
import { DocumentService } from 'src/app/services/document.service';
import { PdfAndImageService } from 'src/app/services/pdf-image.service';
import { StudentService } from 'src/app/services/student.service';
import { AuthStore } from 'src/app/stores/auth.store';
import { Constants } from '../../constants/constants';
import {
  dialogAnimationDuration,
  dialogTimer,
} from '../../constants/dialog-specs';
import {
  AGENCY_DATA_LENGTH,
  END_DAY,
  IS_ADOPTIVE,
  IS_AGENCY,
  SEIT,
  START_DAY,
} from '../../constants/document-upload';
import { NOTIFICATION_MESSAGES } from '../../constants/notification-messages';
import {
  ADDITIONAL_MINUTE,
  ADDITIONAL_MONTH,
  SUMMARY_MAX_DAY,
  SUMMARY_MAX_MONTH_INDEX,
  SUMMARY_MIN_DAY,
  SUMMARY_MIN_MONTH_INDEX,
} from '../../constants/time-constants';
import { DocumentType } from '../../enums/document-types';
import { utcToDateWithoutLosingDateValue } from '../../functions/utc-to-date';
import { ProviderServices, TextFieldName } from '../../interfaces/document';
import { Reason } from '../../interfaces/reason';
import { ParentsInfo } from '../../interfaces/student';
import { StudentDocument } from '../../interfaces/student-document';
import { User } from '../../models/user';
import { StudentProfile } from '../../interfaces/student-profile';
import { Month } from '../../enums/months';
import { Relationship } from '../../enums/relationship-types';
import { kendoDateFormat } from '../../constants/dates';
import { ReferenceValueResponse } from 'src/app/modules/evaluations/interfaces/reason-for-delay';
import { ReferenceStore } from 'src/app/stores/reference.store';
import { ConsentsForReferral } from 'src/app/modules/consent/interfaces/consent';
import { VwLcgmsSeitLocation } from 'src/app/modules/administration/interfaces/lcgms-seit-location';
import {
  DashboardIEPResponse,
  Mandate,
} from 'src/app/modules/dashboard/interface/dashboard-response';

@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss'],
  standalone: false,
})
export class DocumentUploadComponent implements OnInit {
  user: User;
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Input() studentDetails: any;
  @Input() referralSk: any;
  @Input() nycId: string;
  @Input() documents: StudentDocument[] = [];
  // TODO: Right now we are not changing name of this dialog as we need to change in the entire application
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any250117386
  selectedFiles: any[] = [];
  form: FormGroup;
  uploadDocumentList: ReferenceValueResponse[];
  providerServices: ProviderServices[] = Constants.PROVIDER_SERVICES;
  consentInitial: boolean;
  dep1: boolean;
  loadSpinner: boolean;
  relationshipList: Reason[] = Constants.CONTACTS;
  relationOther: number;
  showPlacementDate: boolean;
  showOther: boolean;
  disabledDates = [];
  studentDetail: any; // TODO: Will need to change this
  todayDate: Date = new Date();
  showDateSigned: boolean;
  public summaryMinDate: Date = new Date(
    new Date().getFullYear(),
    SUMMARY_MIN_MONTH_INDEX,
    SUMMARY_MIN_DAY
  );
  public summaryMaxDate: Date = new Date(
    new Date().getFullYear() + SUMMARY_MIN_DAY,
    SUMMARY_MAX_MONTH_INDEX,
    SUMMARY_MAX_DAY
  );
  public format: FormatSettings = kendoDateFormat;
  public placementDisabledDates: Date[] = [];
  showPartialServiceProvided: boolean;
  isSaveDisabled: boolean = false;
  showRequiredMark: boolean = false;
  showRequired: boolean;
  consentReferralList: ConsentsForReferral[];
  consentDetails: any;
  showConsentFields: boolean;
  showDocuments: boolean;
  documentTypeDetails: ReferenceValueResponse;
  agencyData: any;
  selectedAgency: any;
  isSEITApplicable: boolean = undefined;
  minConsentDate: Date;
  textFieldName: TextFieldName = {
    agency: 'Agency Name',
    location: 'Location Code',
  };
  isSEITOnly: boolean = false;

  showConfirmationDialog: boolean;
  isSEITPresent: boolean;
  isDateSignedReadonly: boolean = false;

  readonly filesForUpload: number[] = [
    Number(DocumentType.ConsentForInitialProvisionOfServices),
    Number(DocumentType.PreschoolAcceptanceLetter),
    Number(DocumentType.DEP1),
    Number(DocumentType.STAC),
    Number(DocumentType.PartiallyServedNotice),
    Number(DocumentType.VarianceNotification),
    Number(DocumentType.ConsentForWaiverOfIEPMeeting),
    Number(DocumentType.ConsentForAdditionalAssessments),
    Number(DocumentType.ProgressReport),
    Number(DocumentType.FunctionalBehaviorAssessmentFBA),
  ];

  readonly consentForAdditionalAssessmentId: number = Number(
    DocumentType.ConsentForAdditionalAssessments
  );

  readonly progressReportId: number = Number(DocumentType.ProgressReport);

  constructor(
    private notificationService: NotificationService,
    private studentService: StudentService,
    private pdfAndImageService: PdfAndImageService,
    private authStore: AuthStore,
    private fb: FormBuilder,
    private documentService: DocumentService,
    private dashboardService: DashboardService,
    private adminService: AdminService,
    // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
    private iepService: IEPService<any>,
    private referenceStore: ReferenceStore
  ) {
    this.user = this.authStore.UserInfo;
    this.createForm();
  }

  closeDialog(): void {
    this.close.emit(false);
  }

  ngOnInit(): void {
    this.getSummaryValidation();
    this.placementAuthorizationDate();
    this.loadSpinner = true;

    this.referenceStore.documentType$.subscribe(
      (data: ReferenceValueResponse[]) => {
        this.uploadDocumentList = data.filter(
          (docType: ReferenceValueResponse) =>
            this.filesForUpload.includes(Number(docType.id))
        );
      }
    );

    this.studentService
      .studentProfile(this.nycId)
      .subscribe((response: StudentProfile) => {
        this.studentDetail = { ...response };
        this.loadSpinner = false;
      });

    this.form
      .get('documentType')
      .valueChanges.pipe(startWith(this.form.get('documentType')))
      .subscribe((data: ReferenceValueResponse) => {
        this.showRequiredMark = false;
        this.documentTypeDetails = data;
        this.consentDetails = null;
        this.isDateSignedReadonly = false;
        if (data) {
          if (
            data?.id ===
              Number(
                DocumentType.WrittenNotificationAndOptOutRequirementsAndTimelineParentForm
              ) ||
            data?.id ===
              Number(DocumentType.ConsentForInitialProvisionOfServices) ||
            data?.id === Number(DocumentType.ConsentForWaiverOfIEPMeeting)
          ) {
            this.showRequiredMark = true;
            this.consentInitial = true;
            this.showPlacementDate = false;
            this.dep1 = false;
            this.showDateSigned = true;
            this.showRequired = false;
          } else if (data?.id === Number(DocumentType.DEP1)) {
            this.consentInitial = false;
            this.showPlacementDate = false;
            this.dep1 = true;
            this.showRequired = false;
            this.showDateSigned = true;
          } else if (
            data?.id === Number(DocumentType.PreschoolAcceptanceLetter)
          ) {
            this.checkSeitProgram();
            this.showPlacementDate = true;
            this.consentInitial = false;
            this.dep1 = false;
            this.showDateSigned = false;
            this.showRequired = false;
            if (_.isUndefined(this.isSEITApplicable))
              this.getSEITAvailableForPAL();
            this.showRequired = false;
            if (_.isUndefined(this.isSEITApplicable))
              this.getSEITAvailableForPAL();
          } else if (data?.id === Number(DocumentType.STAC)) {
            this.showPlacementDate = false;
            this.consentInitial = false;
            this.dep1 = false;
            this.showDateSigned = false;
            this.showRequired = false;
          } else if (
            data?.id === Number(DocumentType.ConsentForAdditionalAssessments)
          ) {
            this.showRequiredMark = true;
            this.consentInitial = true;
            this.showPlacementDate = false;
            this.dep1 = false;
            this.showDateSigned = true;
            this.showRequired = true;
            this.getConsentsList();
          } else {
            this.consentInitial = false;
            this.showPlacementDate = false;
            this.dep1 = false;
            this.showRequired = false;
            this.showDateSigned = true;
          }
          if (
            data?.id !== Number(DocumentType.ConsentForAdditionalAssessments)
          ) {
            this.showConsentFields = false;
            this.showDocuments = false;
            this.form?.get('filesList').setValidators([Validators.required]);
            this.form.get('filesList').updateValueAndValidity();
          }
          if (data?.id !== Number(DocumentType.PreschoolAcceptanceLetter)) {
            // clear previously captured seit details
            this.selectedAgency = null;
            this.agencyData = null;
            this.form.get('agencyName').setValue('');
            this.form.get('locationCode').setValue('');
          }
          if (
            data?.id === Number(DocumentType.ConsentForAdditionalAssessments)
          ) {
            this.form?.get('request').setValidators([Validators.required]);
            this.form.get('request').updateValueAndValidity();
          } else {
            this.form?.get('request').removeValidators([Validators.required]);
            this.form.get('request').updateValueAndValidity();
          }
        }
        const requiredIds: number[] = [
          Number(
            DocumentType.WrittenNotificationAndOptOutRequirementsAndTimelineParentForm
          ),
          Number(DocumentType.ConsentForInitialProvisionOfServices),
          Number(DocumentType.ConsentForWaiverOfIEPMeeting),
          Number(DocumentType.ConsentForAdditionalAssessments),
          Number(DocumentType.DEP1),
        ];
        if (requiredIds.includes(Number(data?.id))) {
          this.form.get('dateSigned').addValidators(Validators.required);
          this.form.get('dateSigned').updateValueAndValidity();
          this.showRequiredMark = true;
        } else {
          this.form.get('dateSigned').removeValidators(Validators.required);
          this.form.get('dateSigned').updateValueAndValidity();
          this.showRequiredMark = false;
        }
        if (data?.id === Number(DocumentType.PartiallyServedNotice)) {
          this.showPartialServiceProvided = true;
        } else {
          this.showPartialServiceProvided = false;
        }
        const requiredConsentIds: number[] = [
          Number(
            DocumentType.WrittenNotificationAndOptOutRequirementsAndTimelineParentForm
          ),
          Number(DocumentType.ConsentForInitialProvisionOfServices),
          Number(DocumentType.ConsentForWaiverOfIEPMeeting),
        ];
        if (requiredConsentIds.includes(Number(data?.id))) {
          this.form
            .get('parentGuardianProvidedConsent')
            .addValidators(Validators.required);
          this.form
            .get('parentGuardianProvidedConsent')
            .updateValueAndValidity();
        } else {
          this.form.get('parentGuardianProvidedConsent').clearValidators();
          this.form
            .get('parentGuardianProvidedConsent')
            .updateValueAndValidity();
        }
      });

    this.form
      .get('relationshipRRR')
      .valueChanges.pipe(startWith(this.form.get('relationshipRRR')))
      .subscribe((data: { id: number; description: string }) => {
        if (data?.id === Relationship.Aunt) {
          this.showOther = true;
        } else {
          this.showOther = false;
        }
      });

    this.form
      .get('request')
      .valueChanges.pipe(startWith(this.form.get('request')))
      .subscribe((data) => {
        if (data) {
          const details = data;
          this.consentDetails = details;
          this.consentDetails.validFromDate = details?.validFromDate
            ? moment(details?.validFromDate)?.format('YYYY-MM-DD')
            : '';
          this.showConsentFields = this.form?.value?.documentType?.id
            ? true
            : false;
          if (
            this.form?.value?.documentType?.id ===
            Number(DocumentType.ConsentForAdditionalAssessments)
          )
            this.isDateSignedReadonly =
              this.consentDetails && !this.consentDetails.consentDate
                ? true
                : false;
          if (this.consentDetails?.outcome) {
            // if consent already exists
            this.isSaveDisabled = true;
            this.showDocuments = true;
            this.showRequiredMark = false;
            this.consentInitial = false;
            this.showDateSigned = false;
            // clearing if any existing files, datesigned, and parents consent as not needed
            this.form?.get('filesList').reset();
            this.form?.get('dateSigned').reset();
            this.form?.get('parentGuardianProvidedConsent').reset();
            this.form?.get('filesList').setValidators([]);
            this.form?.get('filesList').setErrors(null);
            this.form.get('dateSigned').removeValidators(Validators.required);
            this.form?.get('dateSigned').setErrors(null);
            this.form.get('parentGuardianProvidedConsent').setValidators([]);
            this.form?.get('parentGuardianProvidedConsent').setErrors(null);
          } else {
            //if consent Not available
            this.showDocuments = false;
            this.showRequiredMark = true;
            this.consentInitial = true;
            this.showDateSigned = true;
            this.minConsentDate = this.consentDetails.consentDate
              ? utcToDateWithoutLosingDateValue(this.consentDetails.consentDate)
              : null;
            this.form?.get('filesList').setValidators([Validators.required]);
            this.form.get('dateSigned').addValidators(Validators.required);
            this.form
              .get('parentGuardianProvidedConsent')
              .setValidators(Validators.required);
          }
          this.form.get('dateSigned').updateValueAndValidity();
          this.form?.get('filesList').updateValueAndValidity();
          this.form
            .get('parentGuardianProvidedConsent')
            .updateValueAndValidity();
        }
      });
  }

  public getConsentsList(): void {
    this.dashboardService
      .getConsentsForReferral(this.studentDetails?.referralSK)
      .subscribe((response: ConsentsForReferral[]) => {
        this.consentReferralList = response;
        this.loadSpinner = false;
      });
  }

  getSEITAvailableForPAL(): void {
    this.iepService
      .getSEITApplicableForPAL(this.studentDetail?.studentSk)
      .subscribe((res: boolean) => {
        this.isSEITApplicable = res;
      });
  }

  placementAuthorizationDate(): void {
    const currentYear: number = new Date().getFullYear();
    const previousYear: number = new Date().getFullYear() + ADDITIONAL_MINUTE;

    // Generate dates for July (6th month in JavaScript, as months are 0-based)

    for (let day: number = START_DAY; day <= END_DAY; day++) {
      this.placementDisabledDates.push(
        new Date(currentYear, SUMMARY_MIN_MONTH_INDEX, day)
      );
    }

    // Generate dates for August (7th month in JavaScript)

    for (let day: number = START_DAY; day <= END_DAY; day++) {
      this.placementDisabledDates.push(
        new Date(currentYear, SUMMARY_MAX_MONTH_INDEX, day)
      );
    }
    for (let day: number = START_DAY; day <= END_DAY; day++) {
      this.placementDisabledDates.push(
        new Date(previousYear, SUMMARY_MIN_MONTH_INDEX, day)
      );
    }

    // Generate dates for August (7th month in JavaScript)

    for (let day: number = START_DAY; day <= END_DAY; day++) {
      this.placementDisabledDates.push(
        new Date(previousYear, SUMMARY_MAX_MONTH_INDEX, day)
      );
    }
  }

  getSummaryValidation(): void {
    const currentYear: number = new Date().getFullYear();
    const previousYear: number = currentYear;
    // Generate dates from September of the previous year to December of the previous year
    for (
      let month: number = Month.September;
      month <= Month.December;
      month++
    ) {
      // September is month 8 (0-based)
      const daysInMonth: number = new Date(
        previousYear,
        month + ADDITIONAL_MONTH,
        Month.January
      ).getDate();
      // Get number of days in the month
      for (let day: number = START_DAY; day <= daysInMonth; day++) {
        this.disabledDates.push(new Date(previousYear, month, day));
      }
    }
    // Generate dates from January to June of the current year
    for (let month: number = Month.January; month <= Month.June; month++) {
      // January is month 0, June is month 5
      const daysInMonth: number = new Date(
        currentYear,
        month + ADDITIONAL_MONTH,
        Month.January
      ).getDate();
      // Get number of days in the month
      for (let day: number = START_DAY; day <= daysInMonth; day++) {
        this.disabledDates.push(
          new Date(currentYear + ADDITIONAL_MONTH, month, day)
        );
      }
    }
  }

  createForm(): void {
    this.form = this.fb.group({
      documentType: [null, [Validators.required]],
      filesList: [null, [Validators.required]],
      parentGuardianProvidedConsent: [null],
      dateSigned: [null],
      chairpersonSignedDate: [null],
      parentSignedDate: [null],
      parentGuardianEIServices: [null],
      parentGuardianPreschoolSpecialEducation: [null],
      parentConsentDate: [null],
      relationshipRRR: [null],
      partialServiceProvided: [null],
      otherCEM: [null],
      printedNameRRR: [null],
      placementAuthorizationDate: [''],
      summerAuthorizationDate: [''],
      request: [null],
      agencyName: [''],
      locationCode: [''],
    });
  }
  checkIfDocTypeIsConsentForAddAssessment(): void {
    if (
      this.form?.value?.documentType?.id ===
        Number(DocumentType.ConsentForAdditionalAssessments) &&
      this.form?.value?.parentGuardianProvidedConsent
    ) {
      this.showConfirmationDialog = true;
    } else {
      this.uploadDocuments();
    }
  }

  uploadDocuments(): void {
    this.isSaveDisabled = true; // Disable the save button
    this.loadSpinner = true;
    const formData: FormData = new FormData();

    if (!this.form.get('filesList')?.value) return;

    // format the date or return an empty string
    const formatDate: (date: any) => string = (date: any): string => {
      return date !== null && moment(date).isValid()
        ? moment(date).format('MM/DD/YYYY')
        : '';
    };

    const filesControl = this.form.get('filesList');
    if (filesControl && filesControl.value) {
      for (const fileObj of filesControl.value) {
        formData.append('type', 'standalone');
        formData.append('id', this.nycId);
        formData.append('studentSk', this.studentDetail?.studentSk);
        formData.append(
          'documentType',
          this.form.value?.documentType?.id ?? ''
        );
        formData.append(
          'parentGuardianProvidedConsent',
          this.form.get('parentGuardianProvidedConsent').value
        );
        formData.append(
          'dateSigned',
          this.form.get('dateSigned')?.value !== null
            ? moment(this.form.get('dateSigned')?.value).format('MM/DD/YYYY')
            : ''
        );
        formData.append(
          'authorizedDate',
          formatDate(this.form.get('placementAuthorizationDate')?.value)
        );
        formData.append(
          'summerAuthorizationDate',
          formatDate(this.form.get('summerAuthorizationDate')?.value)
        );
        if (this.showPlacementDate && this.selectedAgency) {
          formData.append('buildingCode', this.selectedAgency?.buildingCode);
          formData.append('locationCode', this.selectedAgency?.locationCode);
        }

        formData.append('formJson', JSON.stringify(this.form.value));
        if (
          this.documentTypeDetails?.id ===
          Number(DocumentType.ConsentForAdditionalAssessments)
        ) {
          formData.append(
            'caseActionSk',
            this.form.get('request').value?.consentSk
          );
        } else if (
          this.documentTypeDetails?.id ===
          Number(DocumentType.FunctionalBehaviorAssessmentFBA)
        ) {
          formData.append('caseActionSk', this.studentDetails?.referralSK);
        }
        //caseActionSk
        if (fileObj.rawFile) {
          formData.append('file', fileObj.rawFile!);
        } else {
          formData.append('file', fileObj);
        }
      }
    }
    this.documentService.uploadDocument(formData).subscribe(
      () => {
        this.notificationService.show({
          content: NOTIFICATION_MESSAGES.saveSuccess,
          cssClass: 'notification-success',
          hideAfter: dialogTimer,
          position: { horizontal: 'center', vertical: 'top' },
          animation: { type: 'slide', duration: dialogAnimationDuration },
          type: { style: 'success', icon: true },
        });
        this.loadSpinner = false;
        this.close.emit();
      },
      () => {
        this.loadSpinner = false;
        this.isSaveDisabled = false;
      }
    );
  }

  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  onRelationshipValChange(val: any): void {
    if (this.studentDetail?.parentDetails?.length) {
      this.relationOther = val.id;
      if (val.id === IS_ADOPTIVE) {
        const type: ParentsInfo = this.studentDetail?.parentDetails.find(
          (item: ParentsInfo) => item.isPrimary
        );
        this.form
          .get('printedNameRRR')
          .setValue(`${type?.firstName} ${type?.lastName}`);
      } else if (val.id === IS_AGENCY) {
        const type: ParentsInfo = this.studentDetail?.parentDetails.find(
          (item: ParentsInfo) => !item.isPrimary
        );

        this.form
          .get('printedNameRRR')
          .setValue(type ? `${type?.firstName} ${type?.lastName}` : '');
      } else {
        this.form.get('printedNameRRR').setValue(''); // Example: Set the value to an empty string
      }
    }
  }

  viewDocument(documentRow: StudentDocument): void {
    this.documentService
      .getDocument(documentRow.documentRef)
      .subscribe((response: Uint8Array) => {
        this.pdfAndImageService.view(response, documentRow.documentFormat);
      });
  }

  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  uploadDocumentPopUp(event: any): void {
    this.documents = [];
    this.selectedFiles = [];

    for (const file of event) {
      const documentObj: StudentDocument = {
        studentSk: this.studentDetails.studentSk,
        uploadDate: new Date(),
        documentName: file.name,
        documentType: file.type,
      };
      this.selectedFiles.push(file);
      this.documents.push(documentObj);
    }
  }

  onAgencySearch(): void {
    this.selectedAgency = null;
    const agencyName: string = this.form?.value?.agencyName;
    const locationCode: string = this.form?.value?.locationCode;
    if (agencyName || locationCode) {
      this.adminService
        .searchAgencyList(agencyName, locationCode)
        .subscribe((res: VwLcgmsSeitLocation[]) => {
          this.agencyData = [...res];
          // If SEIT is present and no agencies are found, keep Save disabled
          if (this.isSEITOnly && res.length === AGENCY_DATA_LENGTH) {
            this.isSaveDisabled = true;
          }
        });
    }
  }

  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  onselectAgency(data): void {
    this.selectedAgency = data;
    if (this.selectedAgency) {
      this.isSaveDisabled = false; // Enable Save when agency is selected
    }
  }

  checkSeitProgram(): void {
    this.dashboardService
      .getIEPData(this.referralSk)
      .subscribe((response: DashboardIEPResponse) => {
        const programs: Mandate[] = response?.programServices?.programs || [];
        // Check if "SEIT" is present
        const seitPrograms: Mandate[] = programs.filter(
          (program: Mandate) => program.mandateType === SEIT
        );
        // Check if "SEIT" is the only program
        this.isSEITOnly =
          seitPrograms.length === programs.length &&
          programs.length > AGENCY_DATA_LENGTH;
        // Check if SEIT is present with other programs
        this.isSEITPresent = seitPrograms.length > AGENCY_DATA_LENGTH;

        // Disabling save only when SEIT is the only program and no agency is selected
        if (this.isSEITOnly && !this.selectedAgency) {
          this.isSaveDisabled = true;
        } else if (this.isSEITPresent && !this.isSEITOnly) {
          this.isSaveDisabled = false;
        } else if (!this.isSEITPresent) {
          this.isSaveDisabled = false;
        }
      });
  }
}
